import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetDashboardData({ commit }, interval) {
    return new Promise(resolve => {
      axios({
        url: "/dashboard",
        params: {
          interval: interval ? interval : "24 hour"
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetStat({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'stat/report',
        params: {
          start_time: list.start_time,
          end_time: list.end_time,
          step: list.step || 'hour',
          group: list.group || null,
        },
        method: 'GET'
      })
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  }
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
